/******************************************************************************
Utils reducer
Hawaiian Macadamia Nut Services
Alexander Self
7/29/19
*******************************************************************************/
import { FETCH_MANAGERS, FETCH_CULT_EMPLOYEES, FETCH_FIELDS, SET_DOCS,
  FETCH_CERTIFICATION, ERROR } from '../actions/types';
let initState = {
  managers: [],
  employees: [],
  fields: [],
  cert: {},
  docs: {
    selected: false,
    selectedDocs: '',
    data: {}
  }
};

export default function UtilsReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_CULT_EMPLOYEES:
      return { ...state,
        employees: action.payload
      };
    case FETCH_MANAGERS:
      return { ...state,
        managers: action.payload
      };
    case FETCH_FIELDS:
      return { ...state,
        fields: action.payload
      };
    case SET_DOCS:
      return { ...state,
        docs: { ...state.docs,
          selected: true,
          selectedDocs: action.payload.title
        }
      };
    case FETCH_CERTIFICATION:
      return { ...state,
        cert: action.payload
      };
    case ERROR:
      return state;
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/utils_reducer.js